import { module } from 'angular';
import templateBuilderFileCurrentDisplay from './builder/display.html';
import templateBuilderFileCurrentAPI from './builder/api.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/file-current/display.html', templateBuilderFileCurrentDisplay);
	$templateCache.put('kform/components/file-current/api.html', templateBuilderFileCurrentAPI);
});
